/* eslint-disable camelcase */
export const HeadersByFieldType: Record<string, string> = {
  text: "Spørgsmål",
  radio: "Spørgsmål",
  descriptive: "Tema",
  notes: "Spørgsmål",
  slider: "Spørgsmål",
  explainer: "",
  signup: "Tilmeldingsformular"
}

export const NumberWithWords: Record<number, string> = {
  1: "ét",
  2: "to",
  3: "tre",
  4: "fire",
  5: "fem",
  6: "seks",
  7: "syv",
  8: "otte",
  9: "ni",
  10: "ti",
  11: "elleve",
  12: "tolv",
  13: "tretten",
  14: "fjorten",
  15: "femten",
  16: "seksten",
  17: "sytten",
  18: "atten",
  19: "nitten",
  20: "tyve"
}
